import healthAPI from 'resources/health'

export const healthCheck = () => healthAPI.check()

export const doubleCheck = () => healthAPI.doubleCheck()
